enum AudioSource {
  BeatSmooth,
  BeatNormal,
  BeatSharp,

  FrequencesLow,
  FrequencesMidLow,
  FrequencesMidHigh,
  FrequencesHigh,

  ClubberLow,
  ClubberMidLow,
  ClubberMidHigh,
  ClubberHigh
}
export default AudioSource;

export const AUDIO_SOURCE_IDS: string[] = [
  'beat-smooth',
  'beat-normal',
  'beat-sharp',

  'frequencies-low',
  'frequencies-midlow',
  'frequencies-midhigh',
  'frequencies-high'
];

export const AUDIO_SOURCE_LABELS: string[] = [
  'Beat Smooth',
  'Beat Normal',
  'Beat Sharp',

  'Low Freq.',
  'Mid-low Freq.',
  'Mid-High Freq.',
  'High Freq.'
];



// WEBPACK FOOTER //
// ./src/audio/AudioSource.ts